import { Box, Flex } from '@chakra-ui/react'
import React from 'react'

// import SocialSignIn from '../LoginRegistration/SocialSignIn';
import StandardSignIn from '../LoginRegistration/StandardSignIn';
import Registration from './Registration';
import Navbar from '../Navbar/Navbar';

const Login = () => {
    return (
        <Box width={"100%"} height={"100vh"}>
            <Navbar></Navbar>
            <Flex justifyContent="center" alignItems="center" height={"100%"}>
                <Box>
                    <Flex direction="column" flexGrow={1} justifyContent={"center"}>
                        <Box marginY={"0"} width="40vw" paddingX={"2rem"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <StandardSignIn></StandardSignIn>
                        </Box>
                        <Box as="hr"></Box>
                        <Box width="40vw" paddingX={"2rem"} marginY="0">
                            <Registration></Registration>
                        </Box>
                    </Flex>
                </Box>
            </Flex>
        </Box>
    )
}
export default Login;